import { useModalWindow } from '@hooks/useModalWindow';
import { AlterarSenhaModal } from '@mod/Login/AlterarSenhaModal';
import React from 'react';
import { AppTopBar } from './AppBar';
import { AppDrawer } from './AppDrawer';
import { AppMain } from './AppMain';

export type AppLayoutProps = {

}

export function AppLayout (props: AppLayoutProps) {
    const [isMenuOpened, setMenuOpened] = React.useState(false);

    const alterarSenhaModal = useModalWindow();

    const handleMenuButtonClick = React.useCallback(() => {
        setMenuOpened(s => !s);
    }, []);

    return (
        <React.Fragment>
            <AppTopBar
                isMenuOpened={isMenuOpened}
                onMenuButtonClick={handleMenuButtonClick}
            />
            
            <AppDrawer 
                alterarSenhaModal={alterarSenhaModal}
                isMenuOpened={isMenuOpened}
                onDrawerMenuButtonClick={handleMenuButtonClick}
            />
            
            <AppMain 
                isMenuOpened={isMenuOpened}
            />
            
            <AlterarSenhaModal 
                modal={alterarSenhaModal} 
            />
        </React.Fragment>
    )
}